<script lang="ts" setup>
import type { StrapiPageError } from '@autobid/strapi-integration/typescript/strapi/Page'
import { useAuctionI18nSwitcher } from '@autobid/ui/composables/auction/useAuctionI18nSwitcher'
import { useAuctionId } from '@autobid/ui/composables/useAuctionId'
import { useAuctionValidator } from '@autobid/ui/composables/useAuctionValidator'
import { provide } from 'vue'

const auctionId = useAuctionId()
await useAuctionValidator(auctionId.value)

const { getAuctionPageLink } = useAuctionI18nSwitcher(auctionId.value)

provide('customI18nLinkFunction', getAuctionPageLink)

function handleError(error: StrapiPageError) {
  showError({
    statusCode: error.code,
    statusMessage: error.message,
  })
}
</script>

<template>
  <autobid-page
    v-if="auctionId"
    key="auction"
    slug="auction"
    ignore-blacklist
    @error="handleError"
  >
    <template #default="{ pageData }">
      <sections-auction-layout-middleware :auction-id="auctionId">
        <CommonStrapiPage v-if="pageData?.page" :page-data="pageData" />
      </sections-auction-layout-middleware>
    </template>
  </autobid-page>
</template>
